import * as moment from 'moment';
import { BaseModel } from './common/base-model';

export interface StudyInterface {
    closes_at: Date;
    created_at: Date;
    deleted_at: Date;
    id: number;
    is_active: boolean;
    is_anonymous: boolean;
    name: string;
    contact_email: string;
    opens_at: Date;
    organizations: Object[];
    respondent_roles: Object;
    results_file: string;
    statistics_settings: Object[];
    study_partner_id: number;
    updated_at: Date;
}

export class StudyModel extends BaseModel{
    attributes: StudyInterface;

    constructor(data = null) {
        super(data);

        if (!data) {
            this.attributes = {
                closes_at: null,
                created_at: null,
                deleted_at: null,
                id: null,
                is_active: null,
                is_anonymous: null,
                name: null,
                contact_email:null,
                opens_at: null,
                organizations: [],
                respondent_roles: null,
                results_file: null,
                statistics_settings: [],
                study_partner_id: null,
                updated_at: null
            };

            return;
        }

        if (this.get('closes_at')) {
            this.set('closes_at', moment(this.get('closes_at')));
        }
        
        if (this.get('deleted_at')) {
            this.set('deleted_at', moment(this.get('deleted_at')));
        }

        if (this.get('opens_at')) {
            this.set('opens_at', moment(this.get('opens_at')));
        }
    }


    //------------------------------------
    // METHODS
    //------------------------------------

    getHasStudyFinished() {
        const closesAt = this.get('closes_at');
        return closesAt && closesAt.isBefore(moment());
    }

    getHasStudyNotStartedYet() {
        const opensAt = this.get('opens_at');
        return opensAt && opensAt.isAfter(moment());
    }

    getIsStudyActive() {
        return !this.getHasStudyNotStartedYet() && !this.getHasStudyFinished();
    }
}


// WEBPACK FOOTER //
// ./src/app/models/study.model.ts